import React from 'react';

const ReminderIcon = ({ size = "small", extraClasses, ...otherProps }) => {
  return (
    <span
      role="img"
      {...otherProps}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--reminder icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <g fill="none" fillRule="evenodd">
            <path d="M.4.4h19.2v19.2H.4z" />
            <path
              stroke="#FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.682 4.575a1.63 1.63 0 11-3.26 0 1.63 1.63 0 013.26 0zm4.683 11.167c-.144-.556-.674-.827-1.076-1.177-.626-.545-.856-1.295-1.048-2.074-.218-.891-.338-1.803-.438-2.714l-.017.004a3.801 3.801 0 00-7.572 0l-.017-.004c-.1.91-.22 1.823-.439 2.714-.19.78-.421 1.529-1.047 2.074-.402.35-.933.62-1.076 1.177-.128.497.098 1.236.658 1.3.38.045 11.034.045 11.414 0 .56-.064.786-.803.658-1.3z"
            />
          </g>
        </svg>
      </span>
    </span>
  );
};

export default ReminderIcon;
